import React, { useEffect } from "react";
import "react-credit-cards/es/styles-compiled.css";
import ShowCard from "./ShowCardNew";
import { get_default_card } from "src/DAL/Payment/Payment";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { useState } from "react";
import { CircularProgress, Button, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },

  emptyIcon: {
    fontSize: "80px",
    color: "#e0e0e0",
    marginBottom: "18px",
  },
  emptyTitle: {
    fontWeight: 700,
    color: "#333",
    marginBottom: "12px",
  },
  emptySubtitle: {
    color: "#666",
    marginBottom: "32px",
    maxWidth: "400px",
  },
  addButton: {
    padding: "10px 32px",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 600,
  },
}));

const PaymentForm = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { userInfo } = useContentSetting();
  const [isLoading, setIsLoading] = useState(true);
  const [inputs, setInputs] = React.useState({
    cvc: "",
    expiry: "",
    focus: "",
    name: "",
    number: "",
    type: "",
  });

  const getCardsDetail = async () => {
    const result = await get_default_card();
    if (result.code == 200) {
      if (result.stripe_card.last4) {
        let month =
          result.stripe_card.exp_month < 10
            ? "0" + result.stripe_card.exp_month
            : result.stripe_card.exp_month;
        setInputs((inputs) => ({
          ...inputs,
          ["cvc"]: "***",
          ["expiry"]: month + "/" + result.stripe_card.exp_year,
          ["name"]: result.stripe_card.name
            ? result.stripe_card.name
            : userInfo.first_name,
          ["number"]: "************" + result.stripe_card.last4,
          ["type"]: result.stripe_card.brand,
        }));
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCardsDetail();
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container">
      {inputs.number ? (
        <ShowCard inputs={inputs} setInputs={setInputs} />
      ) : (
        // <StripeCardChange inputs={inputs} setInputs={setInputs} />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px", textAlign: "center", marginTop: "40px", }}>
          <CreditCardIcon className={classes.emptyIcon} />
          <Typography variant="h6" className={classes.emptyTitle}>
            No Cards Available
          </Typography>
          <Typography variant="body1" className={classes.emptySubtitle}>
            You haven't added any payment methods yet. Add a card to manage your
            payments easily.
          </Typography>
          <button
            className="small-contained-button"
            onClick={() => navigate("/change-card")}
          >
            Add New Card
          </button>
        </Box>
      )}
    </div>
  );
};
export default PaymentForm;

